import { AfterViewInit, Component, inject, signal, Signal } from '@angular/core';
import { GameService } from '../../service/game.service';
import { TranslateService } from '@ngx-translate/core';
import { RouterService } from '../../service/router.service';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from '../header/header.component';
import { UserService } from '../../service/user.service';
import { Language } from '../../enum/language.enum';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  imports: [RouterOutlet, HeaderComponent],
  standalone: true,
})
export class AppComponent implements AfterViewInit {
  protected showNavigation: Signal<boolean> = signal<boolean>(false);
  private readonly gameService = inject(GameService);
  private readonly translateService = inject(TranslateService);
  private readonly routerService = inject(RouterService);
  private readonly userService = inject(UserService);

  constructor() {
    this.userService.loadUser();
    this.translateService.setFallbackLang(Language.EN);

    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') {
        this.gameService.stopCountdown();
      } else if (document.visibilityState === 'visible') {
        this.gameService.startCountdown();
      }
    });
  }

  public ngAfterViewInit(): void {
    this.showNavigation = this.routerService.hasNavigation();
  }
}
